import {z} from 'zod';

import {optionalIsoDate, optionalText} from '../utils/catalogueUi';
import {optionalMoneyInput, priceInput} from '../utils/moneyInput';

// Kept as a plain object so newModelDraft can `.extend` it; window check is applied by consumers.
export const trimSchema = z.object({
  name: z.string().min(1),
  bodyStyle: z.string().trim().min(1),
  type: optionalText,
  validFrom: optionalIsoDate,
  validTo: optionalIsoDate,
  basePriceNet: priceInput,
  costNet: optionalMoneyInput,
});
